export default {
	history: {
		title: "History",
		description:
			"Every change made in the Designer is recorded as a commit: what changed, who changed it and when.",
		refresh: "Refresh",
		columns: {
			change: "Change",
			author: "Author",
			when: "When",
			commit: "Commit",
		},
		empty: "No changes have been recorded yet.",
		shown: "{count} change shown | {count} changes shown",
		older: "Show older changes",
		loadFailed: "The history could not be loaded.",
	},
};
